import { StrictMode } from 'react';
import { useEffect } from 'react';
import { createRoot } from 'react-dom/client';

import { App, AppDevToolsProvider } from '@components/App';
import { Loading } from '@components/Loading';
import { createBrowserRouter } from '@router';
import * as Sentry from '@sentry/react';
import { configureStore } from '@store';
import { ErrorView } from '@views/ErrorView';

import routes from './routes.js';

import './styles/critical.scss';

const store = configureStore();
const basename = import.meta.env.SPZ_APP_BASENAME ?? '/';
const rootComponent = import.meta.env.DEV ? AppDevToolsProvider : undefined;
const errorElement = <ErrorView />;
const fallback = <Loading />;

const router = createBrowserRouter({
  rootComponent,
  errorElement,
  basename,
  routes,
  fallback,
});

Sentry.init({
  dsn: import.meta.env.SPZ_APP_SENTRY_DSN,
  integrations: [
    // See docs for support of different versions of variation of react router
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
    }),
    Sentry.replayIntegration(),
    Sentry.debugIntegration(),
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  tracesSampleRate: 1.0,
  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  environment: import.meta.env.SPZ_APP_ENVIRONMENT,
  // set to true to debug in console
  debug: false,
});

createRoot(document.getElementById('search-widget-root')!).render(
  <StrictMode>
    <App reduxStore={store} router={router} />
  </StrictMode>
);
